module.exports = __webpack_public_path__ + "static/media/solo23.689a3b7e.JPG";